import { Switch, Route } from "react-router-dom";
import { LayoutMaster } from '../modules/layout/LayoutMaster';
import { PrivateRoute } from '../components/PrivateRoute';
import PageNotFound from '../pages/PageNotFound';

import { ActividadesPersonal } from '../pages/Gestion/ActividadesPersonal';
import { Proyectos } from '../pages/registros/Proyectos';
import { Bienvenido } from '../pages/registros/Bienvenido';
import { Reportes } from '../pages/Reportes/Reportes';
import { Tareas } from '../pages/Gestion/Tareas';
import { CronogramaProyectos } from '../pages/registros/CronogramaProyectos';
import { Incidencias } from "../pages/registros/Incidencias";
import { ActividadesIncidencia } from "../pages/Gestion/ActividadesIncidencia";
import { InventarioDominios } from "../pages/GestionConocimiento/InventarioDominios";
import { InventarioSubDominios } from "../pages/GestionConocimiento/InventarioSubDominios";
import { InventarioServidores } from "../pages/GestionConocimiento/InventarioServidores";
import { InventarioServicios } from "../pages/GestionConocimiento/InventarioServicios";
import { LeccionesAprendizaje } from "../pages/GestionConocimiento/LeccionesAprendizaje";
import { DocumentacionTecnica } from "../pages/GestionConocimiento/DocumentacionTecnica";
import { Proyectosv2 } from "../pages/registros/Proyectosv2";
import { DistribucionActividades } from "../pages/usuarios/DistribucionActividades";
import { Tareasv2 } from "../pages/registros/tareasv2";
import {AgendaGanttView} from "../pages/Reportes/AgendaGanttView";
import {ProduccionPorMetas} from "../pages/Gestion/ProduccionPorMetas";

export function PrivateRoutes({ token }) {
    return (
        <>
            {                
                token !== '' && localStorage.getItem('currentLocation') !== '/'
                && (
                    <>
                        <LayoutMaster>
                            <Switch>
                                <PrivateRoute path='/actividades-personal' component={ActividadesPersonal} />
                                <PrivateRoute path='/proyectos' component={Proyectos} />
                                <PrivateRoute path='/proyectosv2' component={Proyectosv2} />
                                <PrivateRoute path='/incidencias' component={Incidencias} />
                                <PrivateRoute path='/bienvenido' component={Bienvenido} />
                                <PrivateRoute path='/consultas-reportes' component={Reportes} />
                                <PrivateRoute path='/tareas' component={Tareas} />
                                <PrivateRoute path='/tareasv2' component={Tareasv2} />
                                <PrivateRoute path='/cronograma' component={CronogramaProyectos} />
                                <PrivateRoute path='/actividades-incidencia' component={ActividadesIncidencia} />
                                <PrivateRoute path='/inventario-dominios' component={InventarioDominios} />
                                <PrivateRoute path='/inventario-subdominios' component={InventarioSubDominios} />
                                <PrivateRoute path='/inventario-servidores' component={InventarioServidores} />
                                <PrivateRoute path='/inventario-servicios' component={InventarioServicios} />
                                <PrivateRoute path='/lecciones-aprendizaje' component={LeccionesAprendizaje} />
                                <PrivateRoute path='/documentacion-tecnica' component={DocumentacionTecnica} />
                                <PrivateRoute path='/distribucion-actividades' component={DistribucionActividades} />
                                <PrivateRoute path='/agenda-gantt' component={AgendaGanttView} />
                                <PrivateRoute path='/gestion-produccion-por-metas' component={ProduccionPorMetas} />
                                <Route path="*" component={PageNotFound} />
                            </Switch>
                        </LayoutMaster>
                    </>
                )
            }            
        </>
    )
}